import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
import Theme from '../../../Themes/main.theme';
import TitleLayout from '../../../components/layout/TitleLayout';
import AutocompleteInput from '../../../components/Inputs/AutocompleteInput';
import { SimpleAccordion } from './_features/SimpleAccordion';
import FormSkeleton from '../../../components/Skeletons/FormSkeleton';
import { useTranslation } from 'react-i18next';
import i18n from '../../../i18n';


interface IAllAvailableApplicationsProps {
  isLoading: boolean;
  applications: any[];
  redirectsOutsideShadow: boolean;
  tomeas: { label: string, value: string }[];
}
function AllAvailableApplications(props: IAllAvailableApplicationsProps) {
  const { applications = [], tomeas = [], redirectsOutsideShadow, isLoading } = props;
  const [orderedBySector, setOrderedBySector] = React.useState<any>([]);
  const [selectedTomea, setSelectedTomea] = React.useState<
    { label: string, value: string } | null
  >(null);

  const { t } = useTranslation();
  const handleSelectedTomea = (_: any, tomeas: { label: string, value: string }) => {
    setSelectedTomea(tomeas);
  };

  React.useEffect(() => {
    const ordered1 = applications?.reduce((acc, appl) => {
      const section_id = appl?.appl_section?.descr;
      if (!acc?.[section_id]) {
        acc[section_id] = [];
      }
      acc[section_id].push(appl);
      return acc;
    }, {});
    const arrayOfObj = Object.entries(ordered1).map((e) => ({ [e[0]]: e[1] }));
    setOrderedBySector(arrayOfObj);

  }, [applications]);

  return (<>
    <TitleLayout>

      <Typography variant='h2' color={Theme.palette.primary.main}>{t('Αιτήματα στο ΕΚΟΜΕ')}</Typography>

      <Box width='400pxx'>
        <AutocompleteInput
          onChange={handleSelectedTomea}
          optionsList={tomeas}
          placeholder={t('Επιλογή Τομέων')} />
      </Box>
      {isLoading
        ? <FormSkeleton lines={5} />
        : orderedBySector.map((x: any) => {
          const sectionTitle = Object.keys(x)[0];
          const sectionsValues = x[sectionTitle];          
          const shouldRenderTomea = selectedTomea
            ? sectionTitle === selectedTomea.label
            : true;
          return shouldRenderTomea && <SimpleAccordion
            key={sectionTitle}
            title={t(sectionTitle)}
            redirectsOutsideShadow={redirectsOutsideShadow}
            accordions={sectionsValues.map((y: any) => {
              return y.isReactApplication
                ? {
                  title: t(y.appl_title_naming.title),
                  description: t(y.form_description),
                  formTypeId: y?.form_form?.application_form_type_id,
                  linkUrl: y.isReactApplication
                    ? y.redirectUri
                    : y.id
                      ? `/applications/${y.appl_section.form_form.find((x: any) => x.title_naming_id == y.id).id}`
                      : '',
                } 
                : i18n.language === y?.form_form?.language[0]?.value && {
                  title: t(y.appl_title_naming.title),
                  description: t(y.form_description),
                  formTypeId: y?.form_form?.application_form_type_id,
                  linkUrl: y.isReactApplication
                    ? y.redirectUri
                    : y.id
                      ? `/applications/${y.appl_section.form_form.find((x: any) => x.title_naming_id == y.id).id}`
                      : '',
                };  
            }).filter((z: any) => z)}
          />;
        })}
    </TitleLayout>

  </>);
}

export default AllAvailableApplications;

